export const formatNumber = (value, decimalPlaces = 2) => {
  if (value === "" || value === null || value === undefined) {
    return "";
  }

  const stringValue = String(value);

  // Remove thousand separator
  const rawValue = stringValue.replace(/\./g, "");

  const parts = rawValue.split(",");

  // Prevent invalid decimal separator
  if (parts.length > 2) {
    return "";
  }

  const integerPart = parts[0].replace(/\D/g, "");
  const decimalPart = parts[1]
    ? parts[1].replace(/\D/g, "").slice(0, decimalPlaces)
    : "";

  if (!integerPart && !decimalPart) {
    return "";
  }

  const formattedInteger = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    "."
  );

  return decimalPart !== ""
    ? `${formattedInteger},${decimalPart}`
    : formattedInteger;
};

export const parseNumber = (value) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  return Number(
    String(value)
      .replace(/\./g, "")
      .replace(",", ".")
  );
};